import axios from 'axios';

import history from './history';
import config from '../config';

import UserAPI from './UserAPI';

const apiPath = config.api.proposals;

function url(...rest) {
  return rest.map(val => `${val}`.replace(/\/$/, '')).join('/');
}

/*
  Find roles available within this specific proposal
*/

class RoleAPI {
  static get(proposalId, searchParams = undefined) {
    return axios({
      method: 'get',
      url: url(apiPath, proposalId, 'roles'),
      params: searchParams,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }
}

export default RoleAPI;
